import React from 'react';
import './project-footer.css';

export default function ProjectFooter({onAbout}){
 return <footer className="project-footer" role="contentinfo" aria-label="計畫資訊">
  <div className="project-footer-identity">
   <p className="project-footer-partners"><span>Wikidata Taiwan</span><span className="partner-times" aria-hidden="true">×</span><span>Twinkle AI</span></p>
  </div>
  <nav className="project-footer-links" aria-label="計畫導覽">
   <a href="?view=about" onClick={e=>{if(e.metaKey||e.ctrlKey||e.shiftKey||e.altKey||e.button!==0)return;e.preventDefault();onAbout();}}>關於計畫</a>
  </nav>
 </footer>;
}
